import React, { useEffect, useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Header from 'src/components/App/Header';
import Sidebar from 'src/components/App/Sidebar';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Toolbar from '@mui/material/Toolbar';
import { SidebarOnOffContainer } from './styles';
import { drawerWidth, palette } from 'src/config/theme';
import { useLocation } from 'react-router-dom';
import MenuClose from '../assets/images/sidebar-close.svg';
import MenuOpen from '../assets/images/sidebar-open.svg';
import useResponsive from 'src/components/hooks/useResponsive';
import Footer from 'src/components/App/Footer/Footer';
import storage from 'src/utils/storageUtils';
import theme from 'src/config/theme';

function AppLayout({ children, ...props }) {
  const location = useLocation();
  const { isMobile, isTablet, isDesktop } = useResponsive();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isClosing, setIsClosing] = useState(false);
  const [isPermanentOpen, setIsPermanentOpen] = useState(false);

  useEffect(() => {
    const stored = storage.get('IsPermanentOpen');

    if (isMobile || isTablet) {
      setIsPermanentOpen(true);
    } else {
      setIsPermanentOpen(stored === null ? false : stored === 'true');
    }
  }, [isMobile, isTablet, isDesktop]);

  const handleDrawerClose = () => {
    setMobileOpen(false);
    if (isDesktop) {
      setIsPermanentOpen((prev) => {
        const newState = !prev;
        storage.set('IsPermanentOpen', newState);
        window.dispatchEvent(new Event('sidebarToggled'));
        return newState;
      });
    }
  };

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
    if (isDesktop) {
      if (!isClosing) {
        const newState = !isPermanentOpen;
        setIsPermanentOpen(newState);
        storage.set('IsPermanentOpen', newState);
        window.dispatchEvent(new Event('sidebarToggled'));
      }
    }
  };

  const handleDrawerTransitionEnd = () => {
    setIsClosing(false);
  };

  console.log('props');
  console.log(props);

  useEffect(() => {
    if (location.pathname === '/appointment/Patients') {
      setIsPermanentOpen(false);
      storage.set('IsPermanentOpen', false);
    }
  }, [location.pathname]);


  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />

      {(isMobile || isTablet) && (
        <Sidebar
          window={window}
          mobileOpen={mobileOpen}
          isPermanentOpen={isPermanentOpen}
          handleDrawerClose={handleDrawerClose}
          handleDrawerTransitionEnd={handleDrawerTransitionEnd}
        />
      )}
      {isDesktop && (
        <>
          <Sidebar
            window={window}
            mobileOpen={mobileOpen}
            isPermanentOpen={isPermanentOpen}
            handleDrawerClose={handleDrawerClose}
            handleDrawerTransitionEnd={handleDrawerTransitionEnd}
          />
          <SidebarOnOffContainer isPermanentOpen={isPermanentOpen} onClick={handleDrawerClose}>
            <Box
              component="img"
              src={isPermanentOpen ? MenuClose : MenuOpen}
              color={palette.primary.main}
              alt={isPermanentOpen ? 'Menu Close' : 'Menu Open'}
              sx={{
                display: 'flex',
                width: '24px',
                height: '24px',
                justifyContent: 'center',
                color: theme.palette.primary.main
              }}
            />
          </SidebarOnOffContainer>
        </>
      )}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            md: isPermanentOpen ? `calc(100% - ${drawerWidth}px)` : 'calc(100% - 88px)',
            lg: isPermanentOpen ? `calc(100% - ${drawerWidth}px)` : 'calc(100% - 88px)',
          },
          marginLeft: isPermanentOpen ? 0 : '0px',
          transition: 'all 0.3s ease-in-out',
          marginBottom: 4,
          // marginTop: 1,
          maxWidth: '100vw',
        }}
      >
        <Box>
          <Toolbar
            disableGutters
          >
            <Container maxWidth="xxl" disableGutters sx={{ marginBottom: '83px' }}>
              <Header isPermanentOpen={isPermanentOpen} />
            </Container>
          </Toolbar>
        </Box>
        <Container maxWidth="xxl" disableGutters>
          {/* {children} */}
          {React.Children.map(children, child =>
            React.isValidElement(child) ? React.cloneElement(child, { isPermanentOpen }) : child
          )}
        </Container>

        {(isMobile || isTablet) && (
          <Container maxWidth="xxl" disableGutters sx={{ position: 'fixed', bottom: 0 }}>
            <Footer isPermanentOpen={isPermanentOpen} toggleSidebar={handleDrawerToggle} />
          </Container>
        )}
      </Box>
    </Box>
  );
}
export default AppLayout;





